import type { FunctionComponent } from 'react';
import PlayerDialog from '../../components/organisms/PlayerDialog';

export interface StateProps {
	defaultName?: string;
}

export interface DispatchProps {}

export interface OwnProps {
	onNext: (name: string) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const PlayerScreen: FunctionComponent<Props> = (props: Props) => {
	const { defaultName = '', onNext } = props;

	return <PlayerDialog defaultName={defaultName} onNext={onNext} />;
};

export default PlayerScreen;
